import Config from '../../config/Config'
import { map, mergeMap, catchError, withLatestFrom } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import * as actions from './actions'
import * as authSelectors from '../auth/selectors'
const queryString = require('@promoboxx/query-string-babel')

export const getLocalAdBalances = (action$, state$) => {
  return action$.pipe(
    ofType(actions.GET_LOCAL_AD_BALANCES),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const headers = authSelectors.headersSelector(state)
      const { invitationIds = [] } = action.payload

      if (!headers) {
        throw new Error('Bad or Non-existent auth headers')
      }

      // fields[]=subjectable
      const params = queryString.stringify(
        { invitation_ids: invitationIds },
        { arrayFormat: 'bracket' },
      )

      const settings = {
        method: 'GET',
        responseType: 'json',
        headers,
        url: `${Config.API_BASE}/v2/local_ad_balances?${params}`,
      }
      return ajax(settings).pipe(
        map((payload) => {
          return {
            type: actions.GET_LOCAL_AD_BALANCES_FULFILLED,
            payload: payload.response,
          }
        }),
        catchError((payload) => {
          return of({
            type: actions.GET_LOCAL_AD_BALANCES_REJECTED,
            payload: payload.response,
          })
        }),
      )
    }),
    catchError((payload) => {
      return of({
        type: actions.GET_LOCAL_AD_BALANCES_REJECTED,
        payload,
      })
    }),
  )
}
